module.exports = __webpack_public_path__ + "static/media/IconUser.aa33c33b.svg";